import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import LoginMobileHeader from '../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../components/header/InstituteMobileHeader';
import CRMobileHeader from '../components/header/CRMobileHeader';
import MobileHeader from '../components/header/MobileHeader';
import LoginHeader from '../components/header/LoginHeader';
import InstituteHeader from '../components/header/InstituteHeader';
import CRHeader from '../components/header/CRHeader';
import NonLoginHeader from '../components/header/NonLoginHeader';
import Iconbox3 from '../components/aboutPage/Iconbox3';
import Partner from '../components/partner';
import Footer from '../components/footer';
import Gotop from '../components/gotop';

import img1 from "../assets/images/job/work-icon-1.jpg";
import img2 from "../assets/images/job/work-icon-2.jpg";
import img3 from "../assets/images/job/work-icon-3.jpg";
import { Link } from "react-router-dom";

const Guidlines = () => {
	const [isShowMobile, setShowMobile] = useState(false);
	const handleMobile = () => {
		const getMobile = document.querySelector(".menu-mobile-popup");
		setShowMobile(!isShowMobile);
		!isShowMobile
			? getMobile.classList.add("modal-menu--open")
			: getMobile.classList.remove("modal-menu--open");
	};
	const module = localStorage.getItem('Module')

	return (
		<>
			<Helmet>
				<title>Guidlines | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Guidlines | Jobkikhoj" />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
			{module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
							<MobileHeader handleMobile={handleMobile} />}
			{module === 'Candidate' ? <LoginHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRHeader handleMobile={handleMobile} /> :
							<NonLoginHeader handleMobile={handleMobile} />}

			<section className="term-section main-term-section">
				<div className="container">
					<Tabs className="row tf-tab">
						{/* <div className="col-lg-4">
			   <TabList className="menu-tab tab-term po-sticky">
				 <Tab className="ct-tab">1. Terms </Tab>
				 <Tab className="ct-tab">2. Limitations </Tab>
				 <Tab className="ct-tab">3. Revisions and errata</Tab>
				 <Tab className="ct-tab">4. Site terms of use modifications</Tab>
				 <Tab className="ct-tab">5. Risks</Tab>
			   </TabList>
			 </div> */}
						<div className="col-lg-12 mt-5">
							<div className="content-tab">
								<TabPanel className="term-content animation-tab pl-0">

									<h3 className='mb-2 mt-4' style={{ fontWeight: "bold" }}>Community Guidelines </h3>
									<p className="para-custom-color ms-3">
										Welcome to Khoj, a portal committed to creating a trusted and transparent platform where candidates, recruiters, institutions, and
										companies can connect meaningfully. These community guidelines are designed to ensure a professional, respectful, and secure
										experience for all users. By adhering to these policies, we promote a fair hiring process, foster productive collaborations,
										and uphold the integrity of the job market.
									</p>
									<h5 className="mt-5" style={{ fontWeight: "bold", textTransform: "none" }}> General Guidelines</h5>
									<h6 className='mt-4 ms-3' style={{ fontWeight: "bold" ,textTransform: "none" }}>1. Respect and Professionalism</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Treat all users—candidates, recruiters, institutions, and companies—with courtesy and professionalism.
										</li>
										<li className="para-custom-color">
											Discriminatory, offensive, or abusive language, including hate speech or harassment, is strictly prohibited.
										</li>
										<li className="para-custom-color">
											{" "}
											Ensure that all interactions, including messages, job postings, and applications, maintain a professional tone.

										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold" ,textTransform: "none" }}> 2. Authenticity and Integrity</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Provide accurate and truthful information in your profile, job postings, and applications.
										</li>
										<li className="para-custom-color">
											Fake profiles, misleading job postings, and fraudulent activities will not be tolerated and may result in permanent suspension.
										</li>
										<li className="para-custom-color">
											{" "}
											Employers must post legitimate job opportunities with clear and truthful job descriptions, requirements, and compensation details.
										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold", textTransform: "none"  }}> 3. Privacy and Data Protection</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Respect the privacy of all users. Do not share, sell, or misuse personal information obtained through Khoj.
										</li>
										<li className="para-custom-color">
											Employers and recruiters must use candidates’ information solely for hiring purposes and not for marketing or any other unauthorized activity.
										</li>
										<li className="para-custom-color">
											{" "}
											Users must not share confidential job details or applicant information without consent.
										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold", textTransform: "none"  }}> 4. No Spam or Misuse of the Platform</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Avoid posting duplicate job listings or irrelevant content.
										</li>
										<li className="para-custom-color">
											Unsolicited promotions, advertisements, or mass messaging of users are not allowed.
										</li>
										<li className="para-custom-color">
											{" "}
											Job seekers should only apply to jobs they are genuinely interested in and qualified for.
										</li>
									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold", textTransform: "none"  }}>5. Reporting Violations</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											If you encounter any fraudulent job postings, fake profiles, harassment, or any other policy violation, please report it immediately.
										</li>
										<li className="para-custom-color">
											Khoj reserves the right to review, remove, or suspend any user accounts violating these guidelines.
										</li>

									</ul>



									{/* 2 */}
									<h5 className='mt-5 mb-4' style={{ fontWeight: "bold" }}>Guidelines for Each Audience</h5>
									<h6 className="ms-3" style={{ fontWeight: "bold" }}> 1. For Candidates</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Ensure that your profile contains accurate information about your skills, experience, and qualifications.										</li>
										<li className="para-custom-color">
											Apply only to jobs that match your qualifications and interests.
										</li>
										<li className="para-custom-color">
											{" "}
											Respond professionally and promptly to recruiters and employers.
										</li>
										<li className="para-custom-color">
											{" "}
											Do not misrepresent your credentials or experience.
										</li>
										<li className="para-custom-color">
											{" "}
											Respect interview processes and commitments.
										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold" }}> 2. For Recruiters</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Post genuine job opportunities with clear details about the role, compensation, and expectations.
										</li>
										<li className="para-custom-color">
											Use ethical recruitment practices and ensure transparency in the hiring process.
										</li>
										<li className="para-custom-color">
											{" "}
											Do not engage in spamming or mass outreach without proper context.
										</li>
										<li className="para-custom-color">
											{" "}
											Maintain confidentiality regarding candidate information.
										</li>
										<li className="para-custom-color">
											{" "}
											Provide constructive feedback to candidates whenever possible.
										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold" }}> 3. For Institutions</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Share only authentic opportunities with students and alumni.
										</li>
										<li className="para-custom-color">
											Facilitate a transparent and fair hiring process.
										</li>
										<li className="para-custom-color">
											{" "}
											Encourage students to apply responsibly and prepare adequately for interviews.
										</li>
										<li className="para-custom-color">
											{" "}
											Partner with companies and recruiters that follow ethical hiring practices.
										</li>
										<li className="para-custom-color">
											{" "}
											Maintain the integrity of placement and career support services.
										</li>

									</ul>

									<h6 className="mt-5 ms-3" style={{ fontWeight: "bold" }}> 4. For Companies</h6>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											Ensure job postings contain complete and truthful information about roles and expectations.
										</li>
										<li className="para-custom-color">
											Treat all candidates fairly and avoid any form of bias or discrimination.
										</li>
										<li className="para-custom-color">
											{" "}
											Maintain professionalism in all communications with candidates and recruiters.
										</li>
										<li className="para-custom-color">
											{" "}
											Provide clear updates on hiring processes and timelines.
										</li>
										<li className="para-custom-color">
											{" "}
											Adhere to all labor laws and fair hiring practices.
										</li>

									</ul>

									<h5 className="mt-5 mb-4" style={{ fontWeight: "bold" }}>Commitment to Growth and Feedback</h5>
									<ul className="list-dot">
										<li className="para-custom-color">
											{" "}
											We are committed to continuously improving the Khoj experience.
										</li>
										<li className="para-custom-color">
											Users are encouraged to provide constructive feedback to help enhance the platform’s quality and efficiency.
										</li>

									</ul>
									<p className="para-custom-color mt-5">
										By using Khoj, you agree to these guidelines, ensuring that Khoj remains a trustworthy and professional job portal for everyone.
									</p>

									<p className="para-custom-color">
										For any concerns or inquiries, please contact our support team at <a href="mailto:contact.jobkikhoj@gmail.com">contact.jobkikhoj@gmail.com</a>/ 9220335725.
									</p>
									<h5 className="mt-5" style={{ fontWeight: "bold" }}>Happy Job Hunting! </h5>


									{/* <h6>4. Site terms of use modifications</h6> */}


								</TabPanel>
							</div>
						</div>
					</Tabs>
				</div>
			</section>

			<Footer />


		</>
	)
}

export default Guidlines